<template>
  <panel :class="{ 'panel-collapse': collapse }" :title="title">
    <div slot="toolbar" class="text-right">
      <w-button class="btn-light mr-2" :text="collapse ? 'Rozwiń' : 'Zwiń'" @click="toggleCollapse" />

      <w-button class="btn-danger" text="Usuń ucznia" @click="removeStudent" />
    </div>

    <student v-if="!collapse" ref="student" :schema="schema" />

    <div v-if="!collapse" slot="footer" class="text-right">
      <w-button class="btn-light" text="Zapisz ucznia" @click="valuidateAndSaveStudent" />
    </div>
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { methodsMixin } from '@/mixins/methods';
import { notificationsMixin } from '@/mixins/notifications';

import Student from './Student';

// @vuese
// Zwijanie formularza studenta
// @group document
export default {
  components: { Panel, Student },
  mixins: [methodsMixin, notificationsMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  },
  data() {
    return {
      collapse: false
    };
  },
  computed: {
    title() {
      if (this.schema.data.student.fullName.$model && this.collapse) {
        return this.schema.data.student.fullName.$model;
      }
      return this.schema.data.student.$schema.title;
    }
  },
  mounted() {
    if (!this.schema.id.$model) {
      this.saveStudent().then(() => {
        const documents = this.schema.$parent.$model;
        const documentId = this.schema.id.$model;

        if (documents[documents.length - 1].id === documentId) {
          this.setFocusOnInput('student');
        }
      });
    }
    this.collapseIfFilled();
  },
  methods: {
    // @vuese
    // Przełączanie zwijania
    toggleCollapse(student) {
      if (this.collapse || this.validate()) {
        this.collapse = !this.collapse;
      }
    },
    // @vuese
    // Walidowanie formularza
    validate() {
      if (this.schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return false;
      }
      return true;
    },
    // @vuese
    // Usuwanie ucznia
    removeStudent() {
      this.schema.$removeRow();
    },
    // @vuese
    // Waliduje formularz a następnie zapisuje subdokument ucznia
    valuidateAndSaveStudent() {
      if (this.validate()) {
        this.saveStudent();
      }
    },
    // @vuese
    // Zapisuje subdokument ucznia
    saveStudent() {
      const model = this.schema.$getData();
      return this.$store.dispatch('document/' + (model.id ? 'update' : 'add'), model).then(id => {
        this.notifySuccess(Successes.STUDENT_SAVED);
        this.collapseIfFilled();
        this.schema.id.$setData(id);
      });
    },
    // @vuese
    // Jeżeli wniosek wypełniony
    collapseIfFilled() {
      this.collapse = !this.schema.$validateAll(true).length;
    }
  }
};
</script>

<style>
.panel-collapse .panel-container {
  padding: 0 !important;
}
</style>
